/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyDayInfo,
    JsonEventPartyDayInfoFromJSON,
    JsonEventPartyDayInfoFromJSONTyped,
    JsonEventPartyDayInfoToJSON,
} from './JsonEventPartyDayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyDayInfo
 */
export interface ApiResultOfJsonEventPartyDayInfo {
    /**
     * 
     * @type {JsonEventPartyDayInfo}
     * @memberof ApiResultOfJsonEventPartyDayInfo
     */
    data?: JsonEventPartyDayInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyDayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyDayInfo
     */
    result?: ApiResultOfJsonEventPartyDayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyDayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyDayInfoFromJSON(json: any): ApiResultOfJsonEventPartyDayInfo {
    return ApiResultOfJsonEventPartyDayInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyDayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyDayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyDayInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyDayInfoToJSON(value?: ApiResultOfJsonEventPartyDayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyDayInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

